/**
*
* RedirectButton
* fetch redirect location from url and redirects to it
*
*/

import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { useApi2fetch } from 'containers/Api2/index.js';

function RedirectButton(props) {
  const { fetchOptions, ...otherProps } = props;
  const api2fetch = useApi2fetch();
  const [working, setWorking] = useState(false);
  const fetchStr = JSON.stringify(fetchOptions);

  const handleClick = useCallback(() => {
    setWorking(true);
    api2fetch(fetchOptions)
      .then((resp) => {
        window.location.href = resp.location;
      })
      .finally(() => setWorking(false));
  }, [fetchStr]); // eslint-disable-line react-hooks/exhaustive-deps

  return <Button {...otherProps} onClick={handleClick} disabled={working} />;
}

RedirectButton.propTypes = {
  fetchOptions: PropTypes.object.isRequired,
};

export default RedirectButton;
